import script from "./RegisteredBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisteredBadge.vue?vue&type=script&setup=true&lang=js"

import "./RegisteredBadge.vue?vue&type=style&index=0&id=0de8e09b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de8e09b"]])

export default __exports__